import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd } from '@angular/router';
import { BlockUIService } from './shared/components/block-ui/block-ui.service';
import { AlertNotify } from './shared/types/alert-Notify';
import { LoginService } from './shared/services/login.service';
import { AlertService } from './shared/services/alert.service';
import { LoginVerbiage } from './shared/types/login-verbiage';
import { Subscription } from 'rxjs';

declare const gtag: Function;
declare const webchat: any;

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  alertNotifyList: AlertNotify[] = [];
  showDefaultHeader = true;
  isLogin = false;
  verbiage: LoginVerbiage;
  public isBannerClosed = false;
  private verbiageSubscription: Subscription;

  constructor(
    private router: Router,
    public toastr: ToastrService,
    private loginService: LoginService,
    private alertService: AlertService,
    private blockUI: BlockUIService,
    vRef: ViewContainerRef
  ) { }

  ngOnInit() {
    const bannerClosed = localStorage.getItem('loginBannerClosed');
    if (bannerClosed === 'true') {
      this.isBannerClosed = true;
    }

    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.blockUI.start('Loading...');
      } else if (event instanceof RouteConfigLoadEnd) {
        this.blockUI.stop();
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'UA-152080969-1', {
          page_path: event.urlAfterRedirects,
        });

        const customHeaderRoutes = ['order-summary'];
        const customHeaderValue = event.urlAfterRedirects.split('/')[1];
        this.showDefaultHeader = !customHeaderRoutes.includes(customHeaderValue);
      }
    });

    this.subscribeToVerbiage();
  }

  ngOnDestroy() {
    if (this.verbiageSubscription) {
      this.verbiageSubscription.unsubscribe();
    }
  }

  closeBanner() {
    this.isBannerClosed = true;

    localStorage.setItem('loginBannerClosed', 'true');
  }

  subscribeToVerbiage() {
    this.verbiageSubscription = this.loginService.verbiage.subscribe(
      (verbiage: LoginVerbiage) => {
        this.verbiage = verbiage;
      },
      (error) => {
        console.error('Error receiving verbiage:', error);
        this.toastr.error('Failed to load verbiage. Please try again later.', 'Error');
      }
    );
  }

  async onRouterChange(e) {
    try {
      this.onHideTalkDeskChat();

      if (window.location.pathname == '/login') {
        this.isLogin = true;
        this.alertNotifyList = [];
      } else {
        this.isLogin = false;

        if (this.alertNotifyList.length === 0) {
          const token = this.loginService.getToken();
          await new Promise<void>((resolve, reject) => {
            this.alertService.getAlertsByUser(token.customernumber, token.userName).subscribe(
              (notifications: AlertNotify[]) => this.alertNotifyList = notifications,
              err => {
                console.error(err);
                reject();
              },
              () => resolve());
          });
        }
      }
    } catch (error) {
      console.error('Error fetching alerts:', error);
      this.toastr.error('Failed to load alerts. Please try again later.', 'Error');
    }
  }

  onHideTalkDeskChat() {
    try {
      if (window.location.pathname != '/login') {
        if (webchat != undefined) {
          if (webchat.selfHostedApp != undefined) {
            webchat.selfHostedApp.close();
          }
        }
      }
    } catch (e) {
      console.error('Error hiding TalkDesk chat:', e);
    }
  }
}
